/**************************************************
 * Nombre:       Tarjeta_Piso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Habitaciones from "./Tarjeta_Habitaciones";

const Tarjeta_Piso = ({seleccionada, setSeleccionada, it, habOcupadas}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 2, sm: 12, md: 2}}>
                <Typography sx={{fontSize: 14, fontWeight: 800, lineHeight: 1.1}}>{`Piso ${it.piso}`}</Typography>
            </Grid>

            <Grid container size={{xs: 10, sm: 12, md: 10}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={2}
                >


                    {it.habitaciones.map((item, index) => {
                        return (
                            <Grid container size={{xs: 3, sm: 3, md: 3}}>
                                <Tarjeta_Habitaciones seleccionada={seleccionada} setSeleccionada={setSeleccionada}
                                                      it={item} habOcupadas={habOcupadas}/>
                            </Grid>
                        )
                    })}

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Piso